import { render, staticRenderFns } from "./GuardianChanged.vue?vue&type=template&id=7b3107f0"
import script from "./GuardianChanged.vue?vue&type=script&lang=js"
export * from "./GuardianChanged.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports